import { isMobile } from 'react-device-detect';

// import all jsonFiles (the name of the file must be the same as the incident name)
// const importAllJsonFiles = r => {
//     const jsonFiles = {};
//     r.keys().forEach(item => { jsonFiles[item.replace('./', '')] = r(item); });
//     return jsonFiles;
// };
// const jsonFiles = importAllJsonFiles(require.context('./assets/incidentsForm', false, /\.(json)$/));


// export const getSvg = (pageNumber, incidentName, hasCustomColor = false) => {
//     const image = relatedSvg[incidentName];
//     if (image) {
//         // if (pageNumber === 1) {
//             return image;
//         // }
//         // return hasCustomColor ? jsonFiles[`${incidentName}-white.json`] : jsonFiles[`${incidentName}.json`];
//     }
//     // if (pageNumber === 1) {
//         return relatedSvg.other;
//     // }
//     // return hasCustomColor ? jsonFiles['other-white.json'] : jsonFiles['other.json'];
// };

const disabledModesWhileOffline = ['PASSAGE_VISUALIZATION', 'ISSUE_REPORT', 'DOCUMENT'];
export const shouldDisableQRCodeMode = (mode, isOnline) => !isOnline && disabledModesWhileOffline.includes(mode);

// export const getAnimationOrImgByIncident = (pageNumber, incidentName, hasCustomColor = false) => {
//     const image = relatedSvg[incidentName];
//     if (image) {
//         if (pageNumber === 1) { return image; }
//         return hasCustomColor ? jsonFiles[`${incidentName}-white.json`] : jsonFiles[`${incidentName}.json`];
//     }
//     if (pageNumber === 1) { return relatedSvg.other; }
//     return hasCustomColor ? jsonFiles['other-white.json'] : jsonFiles['other.json'];
// };

export const isPassagesRoute = isMobile
  && (/^\/passages\/[A-Za-z0-9]/.test(window.location.pathname)
    || /^\/nfc-tags\/[A-Za-z0-9]/.test(window.location.pathname)
    || /^\/qrcodes\/[A-Za-z0-9]/.test(window.location.pathname));
